import { createFileRoute } from '@tanstack/react-router';

import { AttributeFormScreen } from '@/features/catalog/AttributeForm';

/** Новый атрибут — отдельная страница: форма занимает экран целиком, а не шторку. */
export const Route = createFileRoute('/_app/catalog_/attributes_/new')({
  component: NewAttributeRoute,
});

function NewAttributeRoute() {
  return <AttributeFormScreen />;
}
